'use client';

import 'react-international-phone/style.css';
import 'app/(web)/checkout/contactform/phoneInputStyle.css';

import { useEffect, useRef, useState } from 'react';
import ROUTES from '@utils/routes';
import { Button } from 'designSystem/Buttons/Buttons';
import { Flex } from 'designSystem/Layouts/Layouts';
import { twMerge } from 'tailwind-merge';

export default function FloatingBottomBarPv({
  threshold,
  isVisible = true,
  className = '',
}: {
  threshold?: number;
  isVisible?: boolean;
  className?: string;
}) {
  const scrollPos = useRef(0);
  const [showBottomBar, setShowBottomBar] = useState(false);
  const recalculateVisibility = () => {
    setShowBottomBar(window.scrollY > (threshold ?? 350));
    scrollPos.current = window.scrollY;
  };

  const handleScroll = () => {
    requestAnimationFrame(() => recalculateVisibility());
  };

  useEffect(() => {
    scrollPos.current = 0;
    recalculateVisibility();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold, handleScroll]);

  return (
    <div
      className={`transition-all fixed bottom-0 left-0 right-0 z-40 ${
        showBottomBar && isVisible ? 'translate-y-[0%]' : 'translate-y-[105%]'
      }`}
    >
      <div className={twMerge(`p-4 ${className}`)}>
        <Flex className="justify-end items-center">
          <a
            href={ROUTES.checkout.clinics}
            id="tmevent_click_floating_button_pv"
          >
            <Button
              as="div"
              size="lg"
              type="primary"
              className="mr-4 pointer-events-auto"
              id="tmevent_click_floating_button_callme"
            >
              Pide cita gratis
            </Button>
          </a>
        </Flex>
      </div>
    </div>
  );
}
